export default "__VITE_ASSET__BvRhzqgQ__"